/**
 * A two-step text action at the smallest button height, flush with the copy. The invisible strip
 * above and below keeps its tap area at 44px (Constitution §VI) without the visible padding.
 */
export const TEXT_ACTION = {
  alignSelf: 'flex-start',
  ml: -1.75,
  height: 28,
  py: 0,
  '&::after': { content: '""', position: 'absolute', inset: '-8px 0' },
} as const;
